import React, { ComponentType, useMemo } from 'react';
import { ItemWidthType, LayoutType } from "@om-fe/widgets/dist/components/nav/nav.constants";
import { NavStatic } from '@om-fe/widgets/dist/components/nav/static/nav-static';
import { NavStaticItemModel } from '@om-fe/widgets/dist/components/nav/static/nav-static.constants';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { AppState } from '@om-fe/core/core/types';
import { BemMethod, createBem } from '@om-fe/utils';
import { useI18NContext } from '@om-fe/core/core/i18n/useI18ncontext';
import { BetslipVirtualBetsTabs } from '@om-fe/widgets/dist/widgets/betting-history/betting-history-open-bet/betting-history-virtual-tab';

export { BetslipVirtualBetsTabs };

interface BetslipVirualTabsProps {
    onTabClick: (tab: BetslipVirtualBetsTabs) => void;
    selectedTab: BetslipVirtualBetsTabs;
    hasVirtualBets?: boolean;
    hasSimulateBetsV2?: boolean;
    routeSimulateBetsV2?: string;
}

interface BetslipTabsStateProps {
    readonly isAuthenticated: boolean;
}

const bem: BemMethod = createBem('BetslipVirtualTabs');

function BetslipVirtualTabsComponent(
    {
        isAuthenticated,
        onTabClick,
        selectedTab,
        hasVirtualBets,
        hasSimulateBetsV2,
        routeSimulateBetsV2,
    }: BetslipVirualTabsProps & BetslipTabsStateProps) {
    const { gettext } = useI18NContext();

    const items = useMemo((): NavStaticItemModel<BetslipVirtualBetsTabs>[] => [
        {
            id: BetslipVirtualBetsTabs.AllBets,
            text: gettext('All Bets'),
        },
        ...(hasVirtualBets ? [{
            id: BetslipVirtualBetsTabs.VirtualBets,
            text: gettext('Virtual Bets'),
        }] : []),
        ...(hasSimulateBetsV2 ? [{
            id: BetslipVirtualBetsTabs.SimulateBetsV2,
            text: gettext('Simulate Bets'),
            route: routeSimulateBetsV2 ? routeSimulateBetsV2 : undefined,
        }] : [])
    ], [gettext, hasVirtualBets, hasSimulateBetsV2, routeSimulateBetsV2]);

    if (!isAuthenticated) {
        return null;
    }

    return (
        <NavStatic<BetslipVirtualBetsTabs>
            className={bem('', selectedTab)}
            activeItemId={selectedTab}
            items={items}
            hasArrows={false}
            itemWidthType={ItemWidthType.ItemFullEqualWidth}
            layoutType={LayoutType.SingleRow}
            onActiveItemChange={onTabClick}
        />
    );
}

export const BetslipHistoryVirtualTabs: ComponentType<BetslipVirualTabsProps> = compose(
    connect((state: AppState) => {
        return {
            isAuthenticated: !!state.session?.info?.isAuthenticated,
        };
    }),
)(BetslipVirtualTabsComponent);
